/* eslint-disable require-jsdoc */
import React, { useEffect } from 'react';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import SpecialityProductsBlock from "./SpecialityProductsBlock.js";
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import * as Theme from '../../theme/index.js';
import Loader from '../../components/Loader.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import PlanDisplayBlock from './PlanDisplayBlock.js';
import { styled } from '@mui/system';
const StyledAccordionSummary = styled(AccordionSummary)(({
  theme
}) => ({
  "&.MuiAccordionSummary-root": {
    padding: "10px",
    border: "none"
  },
  "&.MuiAccordionSummary-root.Mui-expanded": {
    backgroundColor: theme.palette.primary.main,
    margin: "8px 0 8px 0",
    "&>:last-child": {
      color: "#FFFFFF !important"
    }
  },
  "& .MuiAccordionSummary-content": {
    margin: "10px",
    color: Theme.colors.mainTextGrey
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: "10px",
    "&>p": {
      color: `#ffffff`,
      fontWeight: "900",
      fontSize: "24px !important"
    }
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: Theme.colors.mainTextGrey,
    padding: "12px"
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    padding: "12px",
    color: "#fffff"
  },
  '& .MuiAccordionSummary-expandIconWrapper:hover': {
    backgroundColor: "#bfbfbf",
    borderRadius: "50%"
  }
}));
const PlanOverview = props => {
  useEffect(() => {
    if (props.events) {
      props.events.record('view_plan');
    }
  }, []);
  const _getUnusedBenefits = () => {
    const unused = [];
    Object.keys(props.plan).map(benefit => {
      let isUnused = true;
      props.plan[benefit].some(design => {
        if (benefit === 'specialityProducts' && design.coverage && Object.keys(design.coverage).length > 0) {
          isUnused = false;
          return true;
        }
        if (design.coverage?.isSelected) {
          isUnused = false;
          return true;
        }
        return false;
      });
      if (isUnused) {
        unused.push(benefit);
      }
      return null;
    });
    return unused;
  };
  const {
    plan,
    whitelabel
  } = props;
  const styles = {
    contentBlock: {
      backgroundColor: Theme.colors.surface,
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      display: 'block',
      margin: 'auto auto 30px auto',
      padding: '30px',
      position: 'relative',
      zIndex: Theme.zIndex.container
    },
    expansionRoot: {
      boxShadow: 'none'
    },
    expansionSummary: {
      padding: '0',
      '&$expanded': {
        backgroundColor: `${Theme.colors.darkBlue}`,
        color: `${Theme.colors.surface}`
      }
    },
    downloadBtnContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-end',
      marginBottom: 10
    }
  };
  if (!props.plan) {
    return /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    });
  }
  const unusedBenefits = _getUnusedBenefits();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.downloadBtnContainer
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: () => props.downloadPlanDesign(),
    customStyle: {
      '&:hover': {
        backgroundColor: 'lightgrey'
      }
    }
  }, i18n.t(tokens.buttons.download))), /*#__PURE__*/React.createElement("div", {
    style: styles.contentBlock
  }, unusedBenefits.indexOf('lifeInsurance') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.lifeInsurance))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.lifeInsurance,
    type: "lifeInsurance"
  })), unusedBenefits.indexOf('deathDismemberment') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.accidentalDeathAndDismemberment))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.deathDismemberment,
    type: "deathDismemberment"
  })), unusedBenefits.indexOf('dependentLife') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.dependentLife))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.dependentLife,
    type: "dependentLife"
  })), unusedBenefits.indexOf('ltd') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.longTermDisability))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.ltd,
    type: "ltd"
  })), unusedBenefits.indexOf('std') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.shortTermDisability))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.std,
    type: "std"
  })), unusedBenefits.indexOf('criticalIllness') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.criticalIllness))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.criticalIllness,
    type: "criticalIllness"
  })), unusedBenefits.indexOf('dental') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.dental))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.dental,
    type: "dental"
  })), unusedBenefits.indexOf('drugs') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.drugs))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.drugs,
    type: "drugs"
  })), unusedBenefits.indexOf('healthcare') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.healthcare))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.healthcare,
    type: "healthcare"
  })), unusedBenefits.indexOf('outOfCountry') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.outOfCountry))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.outOfCountry,
    type: "outOfCountry"
  })), unusedBenefits.indexOf('efap') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.employeeFamilyAssistance))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.efap,
    type: "efap"
  })), unusedBenefits.indexOf('virtualHealthcare') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.virtualHealthCare))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.virtualHealthcare,
    type: "virtualHealthcare"
  })), unusedBenefits.indexOf('financialAwareness') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.financialAwareness))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.financialAwareness,
    type: "financialAwareness"
  })), unusedBenefits.indexOf('spendingAccounts') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.spendingAccounts))), /*#__PURE__*/React.createElement(PlanDisplayBlock, {
    data: plan.spendingAccounts,
    type: "spendingAccounts"
  })), unusedBenefits.indexOf('specialityProducts') === -1 && /*#__PURE__*/React.createElement(Accordion, {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Text, {
    color: "none"
  }, i18n.t(tokens.titles.specialityProducts))), /*#__PURE__*/React.createElement(SpecialityProductsBlock, {
    data: plan.specialityProducts,
    specialityProductMetaConfigs: props.specialityProductMetaConfigs,
    whitelabel: whitelabel,
    language: props.language || 'en'
  }))));
};
export default PlanOverview;